module.exports = __webpack_public_path__ + "img/pergola.0e98d640.jpg";